module.exports = __webpack_public_path__ + "img/低通锐化3.0b9ed0a0.png";